
import React, { useState } from "react";

// import images
import fromToTrip from "../assets/from-to-trip.png";
import tripRootIcons from "../assets/trip-root-icons.png";
import heartLine from "../assets/heart-line.png";
import { Link } from "react-router-dom";
import FlightDetailsModal from "./FlightDetailsModal";
import { useTranslation } from 'react-i18next'

const BestList = () => {
  const { t } = useTranslation();
     const [showModal, setShowModal] = useState(false);
  return (
    <div className="tabs-trip-box pt-4">
      
      {/* Trip Card */}
      <div className="trip-details d-flex align-items-center mb-3 flex-lg-nowrap flex-wrap">
        <div className="left-details">
          <ul className="list-btn-trip list-unstyled p-0 m-0 d-flex align-items-center gap-2">
            <li>
              <Link to="#" className="btn btn-orange">{t("Best Cheapest")}</Link>
            </li>
            <li>
              <Link to="#" className="btn btn-parrot">{t("Direct")}</Link>
            </li>
            <li>
              <Link to="#" className="btn btn-border border-blue"> {t("Flexible ticket upgrade available")} </Link>
            </li>
          </ul>

          <div className="details-trip-box d-flex align-items-center gap-3">
            <div className="left-from-trip">
              <div className="trip-text-icons-box d-flex align-items-center gap-2">
                <div className="icons">
                  <img src={fromToTrip} alt="from-to" />
                </div>
                <div className="text">
                  <h6>5:20 AM</h6>
                  <span className="text-sub">{t("fromAirport")}</span>
                </div>
              </div>
              <div className="trip-text-icons-box d-flex align-items-center gap-2">
                <div className="icons">
                  <img src={fromToTrip} alt="from-to" />
                </div>
                <div className="text">
                  <h6>9:15 AM</h6>
                  <span className="text-sub">{t("toAirport")}</span>
                </div>
              </div>
            </div>

            <div className="mid-direct-trip">
              <div className="trip-icons">
                <img src={tripRootIcons} alt="route" />
              </div>
              <div className="trip-icons">
                <Link to="#" className="btn btn-parrot"> {t("Direct")} </Link>
              </div>
              <div className="trip-icons">
                <img src={tripRootIcons} alt="route" />
              </div>
            </div>

            <div className="right-to-trip">
              <div className="trip-text-icons-box d-flex align-items-center gap-2">
                <div className="text">
                  <h6>5:20 AM</h6>
                  <span className="text-sub">{t("toAirport")}</span>
                </div>
              </div>
              <div className="trip-text-icons-box d-flex align-items-center gap-2">
                <div className="text">
                  <h6>9:15 AM</h6>
                  <span className="text-sub">{t("fromAirport")}</span>
                </div>
              </div>
            </div>
          </div>

          <div className="trip-vec-box">
            <h6> {t("airIndia")} </h6>
          </div>
        </div>

        <div className="right-details position-relative">
          <div className="right-price-heart-details text-center">
            <span className="heart-icons line-heart">
              <img src={heartLine} alt="heart" />
            </span>
            <div className="price-box d-flex justify-content-center">
              {t("INR")} 67,170.00
            </div>
            <div className="btn-box">
              <Link to="/flight-details" className="btn btn-primary">
                {t("View Details")}
              </Link>
            </div>
            <div className="drop-box-price">
              <Link to="#" className="btn-text d-flex align-items-center gap-2" onClick={() => setShowModal(true)}>
                <span> {t("Explore Ticket Options")} </span>
                <svg width="15" height="9" viewBox="0 0 15 9" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1 1L7.5 7L14 1" stroke="#33A7F6" strokeWidth="2" strokeLinecap="round" /></svg>
              </Link>
            </div>
          </div>
        </div>
      </div>

       
      {/* Trip Card */}
      <div className="trip-details d-flex align-items-center mb-3 flex-lg-nowrap flex-wrap">
        <div className="left-details">
          <ul className="list-btn-trip list-unstyled p-0 m-0 d-flex align-items-center gap-2">
            <li>
              <Link to="#" className="btn btn-orange">{t("Best Cheapest")}</Link>
            </li>
            <li>
              <Link to="#" className="btn btn-parrot">{t("Direct")}</Link>
            </li>
            <li>
              <Link to="#" className="btn btn-border border-blue"> {t("Flexible ticket upgrade available")} </Link>
            </li>
          </ul>

          <div className="details-trip-box d-flex align-items-center gap-3">
            <div className="left-from-trip">
              <div className="trip-text-icons-box d-flex align-items-center gap-2">
                <div className="icons">
                  <img src={fromToTrip} alt="from-to" />
                </div>
                <div className="text">
                  <h6>5:20 AM</h6>
                  <span className="text-sub">{t("fromAirport")}</span>
                </div>
              </div>
              <div className="trip-text-icons-box d-flex align-items-center gap-2">
                <div className="icons">
                  <img src={fromToTrip} alt="from-to" />
                </div>
                <div className="text">
                  <h6>9:15 AM</h6>
                  <span className="text-sub">{t("toAirport")}</span>
                </div>
              </div>
            </div>

            <div className="mid-direct-trip">
              <div className="trip-icons">
                <img src={tripRootIcons} alt="route" />
              </div>
              <div className="trip-icons">
                <Link to="#" className="btn btn-parrot"> {t("Direct")} </Link>
              </div>
              <div className="trip-icons">
                <img src={tripRootIcons} alt="route" />
              </div>
            </div>

            <div className="right-to-trip">
              <div className="trip-text-icons-box d-flex align-items-center gap-2">
                <div className="text">
                  <h6>5:20 AM</h6>
                  <span className="text-sub">{t("toAirport")}</span>
                </div>
              </div>
              <div className="trip-text-icons-box d-flex align-items-center gap-2">
                <div className="text">
                  <h6>9:15 AM</h6>
                  <span className="text-sub">{t("fromAirport")}</span>
                </div>
              </div>
            </div>
          </div>

          <div className="trip-vec-box">
            <h6> {t("airIndia")} </h6>
          </div>
        </div>

        <div className="right-details position-relative">
          <div className="right-price-heart-details text-center">
            <span className="heart-icons line-heart">
              <img src={heartLine} alt="heart" />
            </span>
            <div className="price-box d-flex justify-content-center">
              {t("INR")} 67,170.00
            </div>
            <div className="btn-box">
              <Link to="/flight-details" className="btn btn-primary">
                {t("View Details")}
              </Link>
            </div>
            <div className="drop-box-price">
              <Link to="#" className="btn-text d-flex align-items-center gap-2" onClick={() => setShowModal(true)}>
                <span> {t("Explore Ticket Options")} </span>
                <svg width="15" height="9" viewBox="0 0 15 9" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1 1L7.5 7L14 1" stroke="#33A7F6" strokeWidth="2" strokeLinecap="round" /></svg>
              </Link>
            </div>
          </div>
        </div>
      </div>

        
      {/* Trip Card */}
      <div className="trip-details d-flex align-items-center mb-3 flex-lg-nowrap flex-wrap">
        <div className="left-details">
          <ul className="list-btn-trip list-unstyled p-0 m-0 d-flex align-items-center gap-2">
            <li>
              <Link to="#" className="btn btn-orange">{t("Best Cheapest")}</Link>
            </li>
            <li>
              <Link to="#" className="btn btn-parrot">{t("Direct")}</Link>
            </li>
            <li>
              <Link to="#" className="btn btn-border border-blue"> {t("Flexible ticket upgrade available")} </Link>
            </li>
          </ul>

          <div className="details-trip-box d-flex align-items-center gap-3">
            <div className="left-from-trip">
              <div className="trip-text-icons-box d-flex align-items-center gap-2">
                <div className="icons">
                  <img src={fromToTrip} alt="from-to" />
                </div>
                <div className="text">
                  <h6>5:20 AM</h6>
                  <span className="text-sub">{t("fromAirport")}</span>
                </div>
              </div>
              <div className="trip-text-icons-box d-flex align-items-center gap-2">
                <div className="icons">
                  <img src={fromToTrip} alt="from-to" />
                </div>
                <div className="text">
                  <h6>9:15 AM</h6>
                  <span className="text-sub">{t("toAirport")}</span>
                </div>
              </div>
            </div>

            <div className="mid-direct-trip">
              <div className="trip-icons">
                <img src={tripRootIcons} alt="route" />
              </div>
              <div className="trip-icons">
                <Link to="#" className="btn btn-parrot"> {t("Direct")} </Link>
              </div>
              <div className="trip-icons">
                <img src={tripRootIcons} alt="route" />
              </div>
            </div>

            <div className="right-to-trip">
              <div className="trip-text-icons-box d-flex align-items-center gap-2">
                <div className="text">
                  <h6>5:20 AM</h6>
                  <span className="text-sub">{t("toAirport")}</span>
                </div>
              </div>
              <div className="trip-text-icons-box d-flex align-items-center gap-2">
                <div className="text">
                  <h6>9:15 AM</h6>
                  <span className="text-sub">{t("fromAirport")}</span>
                </div>
              </div>
            </div>
          </div>

          <div className="trip-vec-box">
            <h6> {t("airIndia")} </h6>
          </div>
        </div>

        <div className="right-details position-relative">
          <div className="right-price-heart-details text-center">
            <span className="heart-icons line-heart">
              <img src={heartLine} alt="heart" />
            </span>
            <div className="price-box d-flex justify-content-center">
              {t("INR")} 67,170.00
            </div>
            <div className="btn-box">
              <Link to="/flight-details" className="btn btn-primary">
                {t("View Details")}
              </Link>
            </div>
            <div className="drop-box-price">
              <Link to="#" className="btn-text d-flex align-items-center gap-2" onClick={() => setShowModal(true)}>
                <span> {t("Explore Ticket Options")} </span>
                <svg width="15" height="9" viewBox="0 0 15 9" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1 1L7.5 7L14 1" stroke="#33A7F6" strokeWidth="2" strokeLinecap="round" /></svg>
              </Link>
            </div>
          </div>
        </div>
      </div>
      
       
      {/* Trip Card */}
      <div className="trip-details d-flex align-items-center mb-3 flex-lg-nowrap flex-wrap">
        <div className="left-details">
          <ul className="list-btn-trip list-unstyled p-0 m-0 d-flex align-items-center gap-2">
            <li>
              <Link to="#" className="btn btn-orange">{t("Best Cheapest")}</Link>
            </li>
            <li>
              <Link to="#" className="btn btn-parrot">{t("Direct")}</Link>
            </li>
            <li>
              <Link to="#" className="btn btn-border border-blue"> {t("Flexible ticket upgrade available")} </Link>
            </li>
          </ul>

          <div className="details-trip-box d-flex align-items-center gap-3">
            <div className="left-from-trip">
              <div className="trip-text-icons-box d-flex align-items-center gap-2">
                <div className="icons">
                  <img src={fromToTrip} alt="from-to" />
                </div>
                <div className="text">
                  <h6>5:20 AM</h6>
                  <span className="text-sub">{t("fromAirport")}</span>
                </div>
              </div>
              <div className="trip-text-icons-box d-flex align-items-center gap-2">
                <div className="icons">
                  <img src={fromToTrip} alt="from-to" />
                </div>
                <div className="text">
                  <h6>9:15 AM</h6>
                  <span className="text-sub">{t("toAirport")}</span>
                </div>
              </div>
            </div>

            <div className="mid-direct-trip">
              <div className="trip-icons">
                <img src={tripRootIcons} alt="route" />
              </div>
              <div className="trip-icons">
                <Link to="#" className="btn btn-parrot"> {t("Direct")} </Link>
              </div>
              <div className="trip-icons">
                <img src={tripRootIcons} alt="route" />
              </div>
            </div>

            <div className="right-to-trip">
              <div className="trip-text-icons-box d-flex align-items-center gap-2">
                <div className="text">
                  <h6>5:20 AM</h6>
                  <span className="text-sub">{t("toAirport")}</span>
                </div>
              </div>
              <div className="trip-text-icons-box d-flex align-items-center gap-2">
                <div className="text">
                  <h6>9:15 AM</h6>
                  <span className="text-sub">{t("fromAirport")}</span>
                </div>
              </div>
            </div>
          </div>

          <div className="trip-vec-box">
            <h6> {t("airIndia")} </h6>
          </div>
        </div>

        <div className="right-details position-relative">
          <div className="right-price-heart-details text-center">
            <span className="heart-icons line-heart">
              <img src={heartLine} alt="heart" />
            </span>
            <div className="price-box d-flex justify-content-center">
              {t("INR")} 67,170.00
            </div>
            <div className="btn-box">
              <Link to="/flight-details" className="btn btn-primary">
                {t("View Details")}
              </Link>
            </div>
            <div className="drop-box-price">
              <Link to="#" className="btn-text d-flex align-items-center gap-2" onClick={() => setShowModal(true)}>
                <span> {t("Explore Ticket Options")} </span>
                <svg width="15" height="9" viewBox="0 0 15 9" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1 1L7.5 7L14 1" stroke="#33A7F6" strokeWidth="2" strokeLinecap="round" /></svg>
              </Link>
            </div>
          </div>
        </div>
      </div>
      
      
      {/* Trip Card */}
      <div className="trip-details d-flex align-items-center mb-3 flex-lg-nowrap flex-wrap">
        <div className="left-details">
          <ul className="list-btn-trip list-unstyled p-0 m-0 d-flex align-items-center gap-2">
            <li>
              <Link to="#" className="btn btn-orange">{t("Best Cheapest")}</Link>
            </li>
            <li>
              <Link to="#" className="btn btn-parrot">{t("Direct")}</Link>
            </li>
            <li>
              <Link to="#" className="btn btn-border border-blue"> {t("Flexible ticket upgrade available")} </Link>
            </li>
          </ul>

          <div className="details-trip-box d-flex align-items-center gap-3">
            <div className="left-from-trip">
              <div className="trip-text-icons-box d-flex align-items-center gap-2">
                <div className="icons">
                  <img src={fromToTrip} alt="from-to" />
                </div>
                <div className="text">
                  <h6>5:20 AM</h6>
                  <span className="text-sub">{t("fromAirport")}</span>
                </div>
              </div>
              <div className="trip-text-icons-box d-flex align-items-center gap-2">
                <div className="icons">
                  <img src={fromToTrip} alt="from-to" />
                </div>
                <div className="text">
                  <h6>9:15 AM</h6>
                  <span className="text-sub">{t("toAirport")}</span>
                </div>
              </div>
            </div>

            <div className="mid-direct-trip">
              <div className="trip-icons">
                <img src={tripRootIcons} alt="route" />
              </div>
              <div className="trip-icons">
                <Link to="#" className="btn btn-parrot"> {t("Direct")} </Link>
              </div>
              <div className="trip-icons">
                <img src={tripRootIcons} alt="route" />
              </div>
            </div>

            <div className="right-to-trip">
              <div className="trip-text-icons-box d-flex align-items-center gap-2">
                <div className="text">
                  <h6>5:20 AM</h6>
                  <span className="text-sub">{t("toAirport")}</span>
                </div>
              </div>
              <div className="trip-text-icons-box d-flex align-items-center gap-2">
                <div className="text">
                  <h6>9:15 AM</h6>
                  <span className="text-sub">{t("fromAirport")}</span>
                </div>
              </div>
            </div>
          </div>

          <div className="trip-vec-box">
            <h6> {t("airIndia")} </h6>
          </div>
        </div>

        <div className="right-details position-relative">
          <div className="right-price-heart-details text-center">
            <span className="heart-icons line-heart">
              <img src={heartLine} alt="heart" />
            </span>
            <div className="price-box d-flex justify-content-center">
              {t("INR")} 67,170.00
            </div>
            <div className="btn-box">
              <Link to="/flight-details" className="btn btn-primary">
                {t("View Details")}
              </Link>
            </div>
            <div className="drop-box-price">
              <Link to="#" className="btn-text d-flex align-items-center gap-2" onClick={() => setShowModal(true)}>
                <span> {t("Explore Ticket Options")} </span>
                <svg width="15" height="9" viewBox="0 0 15 9" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1 1L7.5 7L14 1" stroke="#33A7F6" strokeWidth="2" strokeLinecap="round" /></svg>
              </Link>
            </div>
          </div>
        </div>
      </div>
      
       
      {/* Trip Card */}
      <div className="trip-details d-flex align-items-center mb-3 flex-lg-nowrap flex-wrap">
        <div className="left-details">
          <ul className="list-btn-trip list-unstyled p-0 m-0 d-flex align-items-center gap-2">
            <li>
              <Link to="#" className="btn btn-orange">{t("Best Cheapest")}</Link>
            </li>
            <li>
              <Link to="#" className="btn btn-parrot">{t("Direct")}</Link>
            </li>
            <li>
              <Link to="#" className="btn btn-border border-blue"> {t("Flexible ticket upgrade available")} </Link>
            </li>
          </ul>

          <div className="details-trip-box d-flex align-items-center gap-3">
            <div className="left-from-trip">
              <div className="trip-text-icons-box d-flex align-items-center gap-2">
                <div className="icons">
                  <img src={fromToTrip} alt="from-to" />
                </div>
                <div className="text">
                  <h6>5:20 AM</h6>
                  <span className="text-sub">{t("fromAirport")}</span>
                </div>
              </div>
              <div className="trip-text-icons-box d-flex align-items-center gap-2">
                <div className="icons">
                  <img src={fromToTrip} alt="from-to" />
                </div>
                <div className="text">
                  <h6>9:15 AM</h6>
                  <span className="text-sub">{t("toAirport")}</span>
                </div>
              </div>
            </div>

            <div className="mid-direct-trip">
              <div className="trip-icons">
                <img src={tripRootIcons} alt="route" />
              </div>
              <div className="trip-icons">
                <Link to="#" className="btn btn-parrot"> {t("Direct")} </Link>
              </div>
              <div className="trip-icons">
                <img src={tripRootIcons} alt="route" />
              </div>
            </div>

            <div className="right-to-trip">
              <div className="trip-text-icons-box d-flex align-items-center gap-2">
                <div className="text">
                  <h6>5:20 AM</h6>
                  <span className="text-sub">{t("toAirport")}</span>
                </div>
              </div>
              <div className="trip-text-icons-box d-flex align-items-center gap-2">
                <div className="text">
                  <h6>9:15 AM</h6>
                  <span className="text-sub">{t("fromAirport")}</span>
                </div>
              </div>
            </div>
          </div>

          <div className="trip-vec-box">
            <h6> {t("airIndia")} </h6>
          </div>
        </div>

        <div className="right-details position-relative">
          <div className="right-price-heart-details text-center">
            <span className="heart-icons line-heart">
              <img src={heartLine} alt="heart" />
            </span>
            <div className="price-box d-flex justify-content-center">
              {t("INR")} 67,170.00
            </div>
            <div className="btn-box">
              <Link to="/flight-details" className="btn btn-primary">
                {t("View Details")}
              </Link>
            </div>
            <div className="drop-box-price">
              <Link to="#" className="btn-text d-flex align-items-center gap-2" onClick={() => setShowModal(true)}>
                <span> {t("Explore Ticket Options")} </span>
                <svg width="15" height="9" viewBox="0 0 15 9" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1 1L7.5 7L14 1" stroke="#33A7F6" strokeWidth="2" strokeLinecap="round" /></svg>
              </Link>
            </div>
          </div>
        </div>
      </div>

      
      
      {/* Trip Card */}
      <div className="trip-details d-flex align-items-center mb-3 flex-lg-nowrap flex-wrap">
        <div className="left-details">
          <ul className="list-btn-trip list-unstyled p-0 m-0 d-flex align-items-center gap-2">
            <li>
              <Link to="#" className="btn btn-orange">{t("Best Cheapest")}</Link>
            </li>
            <li>
              <Link to="#" className="btn btn-parrot">{t("Direct")}</Link>
            </li>
            <li>
              <Link to="#" className="btn btn-border border-blue"> {t("Flexible ticket upgrade available")} </Link>
            </li>
          </ul>

          <div className="details-trip-box d-flex align-items-center gap-3">
            <div className="left-from-trip">
              <div className="trip-text-icons-box d-flex align-items-center gap-2">
                <div className="icons">
                  <img src={fromToTrip} alt="from-to" />
                </div>
                <div className="text">
                  <h6>5:20 AM</h6>
                  <span className="text-sub">{t("fromAirport")}</span>
                </div>
              </div>
              <div className="trip-text-icons-box d-flex align-items-center gap-2">
                <div className="icons">
                  <img src={fromToTrip} alt="from-to" />
                </div>
                <div className="text">
                  <h6>9:15 AM</h6>
                  <span className="text-sub">{t("toAirport")}</span>
                </div>
              </div>
            </div>

            <div className="mid-direct-trip">
              <div className="trip-icons">
                <img src={tripRootIcons} alt="route" />
              </div>
              <div className="trip-icons">
                <Link to="#" className="btn btn-parrot"> {t("Direct")} </Link>
              </div>
              <div className="trip-icons">
                <img src={tripRootIcons} alt="route" />
              </div>
            </div>

            <div className="right-to-trip">
              <div className="trip-text-icons-box d-flex align-items-center gap-2">
                <div className="text">
                  <h6>5:20 AM</h6>
                  <span className="text-sub">{t("toAirport")}</span>
                </div>
              </div>
              <div className="trip-text-icons-box d-flex align-items-center gap-2">
                <div className="text">
                  <h6>9:15 AM</h6>
                  <span className="text-sub">{t("fromAirport")}</span>
                </div>
              </div>
            </div>
          </div>

          <div className="trip-vec-box">
            <h6> {t("airIndia")} </h6>
          </div>
        </div>

        <div className="right-details position-relative">
          <div className="right-price-heart-details text-center">
            <span className="heart-icons line-heart">
              <img src={heartLine} alt="heart" />
            </span>
            <div className="price-box d-flex justify-content-center">
              {t("INR")} 67,170.00
            </div>
            <div className="btn-box">
              <Link to="/flight-details" className="btn btn-primary">
                {t("View Details")}
              </Link>
            </div>
            <div className="drop-box-price">
              <Link to="#" className="btn-text d-flex align-items-center gap-2" onClick={() => setShowModal(true)}>
                <span> {t("Explore Ticket Options")} </span>
                <svg width="15" height="9" viewBox="0 0 15 9" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1 1L7.5 7L14 1" stroke="#33A7F6" strokeWidth="2" strokeLinecap="round" /></svg>
              </Link>
            </div>
          </div>
        </div>
      </div>


      <FlightDetailsModal show={showModal} handleClose={() => setShowModal(false)} />
    
    </div>
  );
};

export default BestList;
